import { AVATAR_COUNT, avatarURL } from '~/config/avatars.config';

// Avatars tirés dans la banque hébergée par la console (public/avatars/adventurer),
// plus sur l'API publique DiceBear : celle-ci plafonne à 10 req/s et n'est pas
// prévue pour un usage commercial, et ses graines aléatoires ne profitaient
// jamais du cache. Tirage sans remise : pas deux fois la même tête dans le
// carrousel avant d'avoir vu toute la banque.
let deck: number[] = [];

function shuffledIndices() {
    const indices = Array.from({ length: AVATAR_COUNT }, (_, i) => i);
    for (let i = indices.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [indices[i], indices[j]] = [indices[j], indices[i]];
    }
    return indices;
}

/** URL absolue d'un avatar au hasard de la banque. */
export function sampleAvatar() {
    if (deck.length === 0) deck = shuffledIndices();
    return avatarURL(deck.pop() as number);
}
